import { useConvertToRepositoryDialog } from "components/Sandbox/ConvertToRepository/ConvertToRepositoryDialog";
import { useSandboxEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import { Box, Button, Text, Stack, Tooltip } from "prism-react";

import { useGitHubScopes } from "hooks/useGitHubScopes";

export const SandboxGitPanel = () => {
  const { open } = useConvertToRepositoryDialog();

  const [session, sessionApi] = useSession();
  const gitHubScopes = useGitHubScopes();
  const editor = useSandboxEditor();

  // TODO: polish
  // https://linear.app/codesandbox/issue/XTE-452
  const promptGitHubPermissions =
    session.state === "AUTHENTICATED" && !gitHubScopes?.publicRepos;

  const projectLabel = editor.isCloud ? "Devbox" : "Sandbox";

  return (
    <>
      <Stack
        css={{
          paddingBottom: "$4",
          paddingLeft: "$5",
          paddingRight: "$4",
        }}
      >
        <Text>
          Create a repository from your {projectLabel} and supercharge your git
          workflow with version control and our GitHub App.
        </Text>
        <Text>
          Repositories get a live dev environment for every PR, editable
          deployment previews, branchable databases and much more!
        </Text>

        {promptGitHubPermissions ? (
          <Tooltip content="CodeSandbox needs access to your GitHub repositories to perform this action.">
            <Box>
              <Button
                css={{
                  marginTop: "$2",
                  width: "100%",
                }}
                icon="github"
                onClick={() =>
                  sessionApi.signIn({
                    type: "github",
                    includedScopes: "private_repos",
                  })
                }
                variant="secondary"
              >
                Review GitHub permissions
              </Button>
            </Box>
          </Tooltip>
        ) : (
          <Button
            css={{
              marginTop: "$2",
              width: "100%",
            }}
            disabled={session.state !== "AUTHENTICATED"}
            icon="github"
            onClick={() => session.state === "AUTHENTICATED" && open()}
            variant="secondary"
          >
            Create repository
          </Button>
        )}
      </Stack>
    </>
  );
};
